import {
  Button,
  ChevronRightIcon,
  VariationLedgerRow,
  formatLedgerWhen,
  formatSitePlot,
  statusWord,
  type LedgerCollapse,
  type LedgerColumn,
} from '@billda/design-system';
import { VariationHoverCard } from './VariationHoverCard';
import type { VariationLedgerRowModel } from './toVariationRows';

interface VariationsLedgerRowProps {
  row: VariationLedgerRowModel;
  columns: readonly LedgerColumn[];
  collapse: LedgerCollapse;
  onOpen: (row: VariationLedgerRowModel) => void;
}

/**
 * One row of the org-wide variations list. No context menu: admin cancel is a
 * site and pot affordance, and this screen has never offered it.
 */
export function VariationsLedgerRow({
  row,
  columns,
  collapse,
  onOpen,
}: VariationsLedgerRowProps) {
  return (
    <VariationLedgerRow
      columns={columns}
      collapse={collapse}
      workTypeName={row.workTypeName}
      description={row.description}
      status={row.status}
      reference={row.reference}
      bookedBy={row.bookedBy}
      bookedAt={row.bookedAt}
      sitePlot={row.sitePlot}
      showValues={false}
      compactMeta={`${statusWord(row.status)} · ${formatSitePlot(row.sitePlot.site, row.sitePlot.plot)} · ${row.bookedBy} · ${formatLedgerWhen(row.bookedAt)}`}
      hoverCard={
        <VariationHoverCard row={row} onOpenDetails={() => onOpen(row)} />
      }
      actions={
        <Button
          variant="ghost"
          size="icon"
          onClick={() => onOpen(row)}
          aria-label={`Open ${row.workTypeName}`}
          className="size-8"
        >
          <ChevronRightIcon aria-hidden="true" className="size-4" />
        </Button>
      }
      onClick={() => onOpen(row)}
      data-testid={`variation-row-${row.id}`}
    />
  );
}
